<app-header *ngIf="headerContent" [headerContent]="headerContent" [themeContent]="themeContent"></app-header>
<app-form-dynamic-v1 *ngIf="formFlowConfig" [formFlow]="formFlowConfig" [themeContent]="themeContent" [landingTitle]="title"></app-form-dynamic-v1>
<app-thank-you-page-v1 *ngIf="thankYouPageContent" [thankYouPageContent]="thankYouPageContent"></app-thank-you-page-v1>
<app-thank-you-page-mao style="display: none;"></app-thank-you-page-mao>
<app-thank-you-page-tandem  style="display: none;"></app-thank-you-page-tandem>
<app-thank-you-page-upsell style="display: none;"></app-thank-you-page-upsell>
<app-articles *ngIf="articlesConfig" [articlesContent]="articlesConfig" [themeContent]="themeContent"></app-articles>
<app-footer *ngIf="footerContent" [footerContent]="footerContent" [themeContent]="themeContent"></app-footer>

